import axios from 'axios';
import { API } from '../../backend';
import authHeader from '../auth-header';

const changeUserPassword = async (body) => {
    const res = await axios.post(API + 'helper/changeuserpassword/', body,
        {
            headers: authHeader()
        }
    )
    return res;
}
const UserPassword = async (body) => {
    const res = await axios.post(API + 'helper/userpasswordupdate/', body,
        {
            headers: authHeader()
        }
    )
    return res;
}

const AuthUserChangePassword = {
    changeUserPassword,
    UserPassword
}
export default AuthUserChangePassword
